export const TechItems = [
    {
        category: 'web',
        name: 'Spring',
        src: './tech-icons/spring.svg',
        experience: (new Date().getFullYear() - 2020)     
    },
    {
        category: 'web',
        name: 'ReactJS',
        src: './tech-icons/react.svg',
        experience: (new Date().getFullYear() - 2019)     
    },
    {
        category: 'web',
        name: 'NodeJS',
        src: './tech-icons/nodejs.svg',
        experience: (new Date().getFullYear() - 2019)     
    },
    
    {
        category: 'web',
        name: 'Express',
        src: './tech-icons/express.svg',
        experience: (new Date().getFullYear() - 2019)     
    },
    {
        category: 'web',
        name: 'PHP',
        src: './tech-icons/php.svg',
        experience: (new Date().getFullYear() - 2017)     
    },
    {
        category: 'web',
        name: 'Javascript',
        src: './tech-icons/javascript.svg',
        experience: (new Date().getFullYear() - 2015)     
    },
    {
        category: 'none',
        name: 'Bootstrap',
        src: './tech-icons/bootstrap.svg',
        experience: (new Date().getFullYear() - 2015)     
    },
    {
        category: 'web',
        name: 'HTML5',
        src: './tech-icons/html5.svg',
        experience: (new Date().getFullYear() - 2015)   
    },
    {
        category: 'web',
        name: 'CSS3',
        src: './tech-icons/css3.svg',
        experience: (new Date().getFullYear() - 2015)     
    },
    {
        category: 'bd',
        name: 'MySQL',
        src: './tech-icons/mysql.svg',
        experience: (new Date().getFullYear() - 2017)     
    },
    {
        category: 'bd',
        name: 'MariaDB',
        src: './tech-icons/mariadb.svg',
        experience: (new Date().getFullYear() - 2017)     
    },
    {
        category: 'bd',
        name: 'MongoDB',
        src: './tech-icons/mongodb.svg',
        experience: (new Date().getFullYear() - 2019)     
    },
    {
        category: 'bd',
        name: 'SQLite',
        src: './tech-icons/sqlite.svg',
        experience: (new Date().getFullYear() - 2020)     
    },
    {
        category: 'bd',
        name: 'PostgreSQL',
        src: './tech-icons/postgresql.svg',
        experience: (new Date().getFullYear() - 2020)     
    },
    {
        category: 'software',
        name: 'C',
        src: './tech-icons/c.svg',
        experience: (new Date().getFullYear() - 2015)     
    },
    {
        category: 'software',
        name: 'C++',
        src: './tech-icons/cplusplus.svg',
        experience: (new Date().getFullYear() - 2015)     
    },
    {
        category: 'software',
        name: 'Java',
        src: './tech-icons/java.svg',
        experience: (new Date().getFullYear() - 2015)     
    },
    {
        category: 'software',
        name: 'Python',
        src: './tech-icons/python.svg',
        experience: (new Date().getFullYear() - 2018)     
    },
    {
        category: 'software',
        name: 'Electron',
        src: './tech-icons/electron.svg',
        experience: (new Date().getFullYear() - 2019)     
    },
    {
        category: 'software',
        name: 'Bash',
        src: './tech-icons/bash.svg',
        experience: (new Date().getFullYear() - 2018)  
    },
    {
        category: 'app',
        name: 'Java (Android)',
        src: './tech-icons/java.svg',
        experience: (new Date().getFullYear() - 2018)    
    },
    {
        category: 'app',
        name: 'Ionic',
        src: './tech-icons/ionic.svg',
        experience: (new Date().getFullYear() - 2020)    
    },
    {
        category: 'other',
        name: 'Linux',
        src: './tech-icons/linux.svg',
        experience: (new Date().getFullYear() - 2018)    
    },
    {
        category: 'other',
        name: 'Git',
        src: './tech-icons/git.svg',
        experience: (new Date().getFullYear() - 2019)    
    },
    {
        category: 'other',
        name: 'GitHub',
        src: './tech-icons/github.svg',
        experience: (new Date().getFullYear() - 2019)   
    },
    {
        category: 'other',
        name: 'GitLab',
        src: './tech-icons/gitlab.svg',
        experience: (new Date().getFullYear() - 2020)   
    },
    {
        category: 'other',
        name: 'Photoshop',
        src: './tech-icons/photoshop.svg',
        experience: (new Date().getFullYear() - 2018)   
    },
    {
        category: 'other',
        name: 'Illustrator',
        src: './tech-icons/illustrator.svg',
        experience: (new Date().getFullYear() - 2019)    
    },
    {
        category: 'other',
        name: 'Adobe Xd',
        src: './tech-icons/adobexd.svg',
        experience: (new Date().getFullYear() - 2020)    
    },
    {
        category: 'other',
        name: 'Figma',
        src: './tech-icons/figma.svg',
        experience: (new Date().getFullYear() - 2020)    
    },
    {
        category: 'learning',
        name: 'Unity',
        src: './tech-icons/unity.svg',
        experience: 0
    },
    {
        category: 'learning',
        name: 'C#',
        src: './tech-icons/csharp.svg',
        experience: 0  
    },
    {
        category: 'cloud',
        name: 'Firebase',
        src: './tech-icons/firebase.svg',
        experience: (new Date().getFullYear() - 2020)    
    }
]